import { createSelector } from 'reselect';

import { JOBS_SIZE } from '../../constants';
import { eventMetaDataSelector } from '../common/tracking/selectors';
import { SORT_BY } from './constants';

export const archives = (store) => store.apps.archives;
export const location = (store) => store.router.location;

export const jobsPagination = createSelector([
  (store) => store.apps.archives.query,
], (query) => ({
  total: Math.ceil(query.get('total') / JOBS_SIZE),
  current: query.getIn(['query', 'page']) + 1,
  show: query.get('total') > JOBS_SIZE,
}));

export const containerSelector = createSelector([
  archives,
  (store) => store.user,
  jobsPagination,
  eventMetaDataSelector,
],
(filteredState, user, pagination, eventMetaData) => ({
  pagination,
  activeSortMethod: filteredState.query.getIn(['query', 'sort']),
  columns: filteredState.columns,
  filterDate: filteredState.query.get('filterDate'),
  filters: filteredState.query.get('filters'),
  initialized: filteredState.container.get('initialized'),
  inputQuery: filteredState.query.get('inputQuery'),
  jobsTeamSharingEnabled: user.isOrgAdmin() || user.organization.settings.jobs_cross_team_sharing,
  queryError: filteredState.query.get('error'),
  searchLoading: filteredState.container.get('searchLoading'),
  selectedJobs: filteredState.container.get('selectedJobs'),
  siblings: filteredState.container.get('siblings'),
  results: filteredState.query.get('results'),
  savedQueries: filteredState.container.get('savedQueries'),
  sortBy: SORT_BY,
  user,
  jobsLoading: filteredState.query.get('loading'),
  eventMetaData: {
    ...eventMetaData,
    sku_type: 'VDC',
  },
}));

export const isInitialized = createSelector([
  archives,
],
(filteredState) => (
  filteredState.container.get('initialized')
));

export default containerSelector;
